// extracted by mini-css-extract-plugin
module.exports = {"root":"_3J_PZ","collapsed":"_1L10a"};